/*eslint-disable */
import * as localconfig from "../../config/_config.json";

// console.log("base_url", localconfig.redirect_url, process.env);

const fs = {
  base_url: "https://www.cutepress.com/mymatchfoundationpowder",
  portal_url: localconfig.redirect_url,
  logo_url: localconfig.logo_url,
  dir: `${process.env.VUE_APP_PRODUCTION_PATH}`,
  call: async url => {
    return await new Promise((resolve, reject) => {
      fetch(url, {
        method: "GET",
        redirect: "manual"
      })
        .then(res => res.json())
        .then(res => resolve(res))
        .catch(err => {
          console.log("error", err);
          reject(new Error("Unable fetch."));
        });
    });
  },

  subscribe: async store => { }
};

export default fs;
